var _jsxFileName = "/codebuild/output/src1571341075/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/consents/HipaaConsent/index.tsx";
import React from 'react';
import { useSelector } from 'react-redux';
import HipaaOUS from './HipaaOUS';
import HipaaUS from './HipaaUS';
const HipaaConsent = () => {
  const country = useSelector(({
    auth
  }) => auth.include.patient.country);
  if (country === 'US') {
    return /*#__PURE__*/React.createElement(HipaaUS, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(HipaaOUS, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 10
    }
  });
};
export default HipaaConsent;